import React from 'react';
import CapabilityCard from '../components/CapabilityCard';

const PILLAR_ICONS = {
  IDENTITY: '👤',
  DEVICE: '💻',
  NETWORK: '🌐',
  APPLICATION: '⚙️',
  DATA: '🗄️',
  VISIBILITY: '👁️'
};

const PillarColumn = ({
  pillar,
  assessments = [],
  vendorOverlay,
  assessmentMode = false,
  onUpdateAssessment
}) => {
  const pillarVar = `--zt-${pillar.pillar_code.toLowerCase()}`;
  const pillarColor = `var(${pillarVar})`;

  const getAssessment = (capabilityId) => {
    return assessments.find(a => a.zt_capability_id === capabilityId);
  };

  const getVendorCoverage = (capabilityId) => {
    if (!vendorOverlay) return null;
    // Search through pillarCoverage for capability coverage
    for (const pc of vendorOverlay.pillarCoverage || []) {
      if (pc.pillar_code === pillar.pillar_code) {
        return pc.capabilities?.find(c => c.zt_capability_id === capabilityId);
      }
    }
    return null;
  };

  const criticalCount = (pillar.capabilities || []).filter(c => c.ab869_critical || c.is_critical).length;

  return (
    <div className="pillar-column">
      {/* Pillar Header */}
      <div
        className="pillar-column-header"
        style={{ borderTopColor: pillarColor }}
      >
        <div
          className="pillar-icon"
          style={{ backgroundColor: `${pillarColor}22`, color: pillarColor }}
        >
          <span role="img" aria-label={pillar.pillar_name}>
            {PILLAR_ICONS[pillar.pillar_code] || '🔷'}
          </span>
        </div>
        <div className="pillar-header-text">
          <h3 className="pillar-name" style={{ color: pillarColor }}>
            {pillar.pillar_name}
          </h3>
          <div className="pillar-meta">
            <span className="pillar-cap-count">
              {(pillar.capabilities || []).length} capabilities
            </span>
            {criticalCount > 0 && (
              <span className="pillar-critical-count">
                {criticalCount} AB 869
              </span>
            )}
          </div>
        </div>

        {/* Vendor coverage for this pillar */}
        {vendorOverlay && (() => {
          const pc = vendorOverlay.pillarCoverage?.find(p => p.pillar_code === pillar.pillar_code);
          if (!pc) return null;
          const pct = Math.round(pc.coverage_percentage || 0);
          const coverageColor = pct >= 75 ? 'var(--zt-strong)' : pct >= 40 ? 'var(--zt-partial)' : 'var(--zt-gap)';
          return (
            <div className="pillar-vendor-coverage" style={{ color: coverageColor }}>
              {pct}%
            </div>
          );
        })()}
      </div>

      {/* Capabilities */}
      <div className="pillar-capabilities">
        {(pillar.capabilities || []).length === 0 ? (
          <div className="pillar-empty">No capabilities</div>
        ) : (
          (pillar.capabilities || []).map(cap => (
            <CapabilityCard
              key={cap.zt_capability_id}
              capability={cap}
              assessment={getAssessment(cap.zt_capability_id)}
              vendorCoverage={getVendorCoverage(cap.zt_capability_id)}
              pillarColor={pillarColor}
              assessmentMode={assessmentMode}
              onUpdateAssessment={onUpdateAssessment}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default PillarColumn;
